import { SubtitleLabelKey, SubtitleTranslationConfig } from './types'

export const CARD_SEPARATOR = ' • '

export const SUBTITLE_TRANSLATION_CONFIG: SubtitleTranslationConfig = {
  bath: {
    key: 'Campaign.Highlights.NumberOfBathrooms.Short',
    supportsPlural: true,
  },
  floor: { key: 'Campaign.Highlights.FloorLevel' },
  bed: {
    key: 'Campaign.Highlights.NumberOfBedrooms.Short',
    supportsPlural: true,
  },
  room: {
    key: 'Campaign.Highlights.NumberOfRooms.Short',
    supportsPlural: true,
  },
  Hectare: { key: 'Campaign.Surface.Unit.Hectare', supportsPlural: true },
  SquareFoot: {
    key: 'Campaign.Surface.Unit.SquareFoot',
    supportsPlural: true,
  },
  SquareMeter: {
    key: 'Campaign.Surface.Unit.SquareMeter',
    supportsPlural: true,
  },
  SquareYard: {
    key: 'Campaign.Surface.Unit.SquareYard',
    supportsPlural: true,
  },
  unit: { key: 'Chat.Area.Unit', supportsPlural: true },
  from: { key: 'Chat.Area.From' },
  to: { key: 'Chat.Area.To' },
}

export const isSubtitleLabelKey = (value: string): value is SubtitleLabelKey =>
  Object.prototype.hasOwnProperty.call(SUBTITLE_TRANSLATION_CONFIG, value)
